<template>
  <v-widget title="Trainer Terbaik">
    <div slot="widget-content">
      <div
        v-if="trainer_init"
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <v-progress-circular
          indeterminate
          :size="40"
          :width="2"
          color="secondary"
        >
        </v-progress-circular>
      </div>
      <div v-else-if="best_trainers.length">
        <vue-perfect-scrollbar style="max-height: 380px">
          <v-list two-line dense class="pa-0">
            <v-list-tile
              v-for="(item, index) in simple_best_trainers"
              avatar
              v-ripple
              :key="`best-trainers-${index}`"
              :to="{ name: 'TrainerList', query: { id: item.id_trainer } }"
            >
              <v-list-tile-avatar color="secondary">
                <span class="white--text headline">{{
                  item.total_training
                }}</span>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.trainer }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  item.trainer_divisi
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </vue-perfect-scrollbar>
        <v-divider></v-divider>
        <v-btn block flat class="ma-0" @click="nToggle">
          {{ nLocal == -1 ? "Sedikit" : "Banyak" }}
          <v-icon>{{
            nLocal == -1 ? "keyboard_arrow_up" : "keyboard_arrow_down"
          }}</v-icon>
        </v-btn>
      </div>
      <div
        v-else
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <h2>Belum ada data.</h2>
        <v-icon medium>sentiment_very_dissatisfied</v-icon>
      </div>
    </div>
  </v-widget>
</template>

<script>
import _ from "lodash";
import VWidget from "@/components/widgets/VWidget";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState } from "vuex";

export default {
  name: "best-trainers",
  props: {
    n: {
      type: Number,
      default: 5
    }
  },
  components: {
    VWidget,
    VuePerfectScrollbar
  },
  data: () => ({
    nLocal: -1
  }),
  computed: {
    ...mapState("trainer", ["trainer_init"]),
    best_trainers() {
      let trainers = this.$store.getters["trainer/trainerByPeriode"];
      return _.orderBy(
        trainers,
        t => {
          return parseInt(t.total_training);
        },
        "desc"
      );
    },
    simple_best_trainers() {
      return this.best_trainers.filter(
        (_, i) => i < this.nLocal || this.nLocal < 0
      );
    }
  },
  methods: {
    nToggle() {
      if (this.nLocal == -1) this.nLocal = _.cloneDeep(this.n);
      else this.nLocal = -1;
    }
  },
  mounted() {
    this.nLocal = _.cloneDeep(this.n);
  }
};
</script>
